<div class="header-container">
  
  <!-- <a (click)="toggleSidebar()" class="sidebar-toggle" *ngIf="showNav">
    <nb-icon icon="menu-2-outline"></nb-icon>
  </a> -->
  <!-- <nb-actions size="small">
    <nb-action class="user-action" *nbIsGranted="['view', 'user']">
      <nb-user [nbContextMenu]="userMenu" [name]="user?.first_name">
      </nb-user>
    </nb-action>
  </nb-actions> -->
  <span class="header-brand">{{orgName}}</span>
  <!-- <nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
    <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
  </nb-select> -->
  <!-- <ngx-layout-direction-switcher class="direction-switcher"></ngx-layout-direction-switcher> -->
</div>

<div class="header-container">
  <nb-actions size="small">

    <!-- <nb-action class="control-item">
      <nb-search type="rotate-layout"></nb-search>
    </nb-action>
    <nb-action class="control-item" icon="email-outline"></nb-action>
    <nb-action class="control-item" icon="bell-outline"></nb-action>
    <nb-action class="user-action" *nbIsGranted="['view', 'user']" >
      <nb-user [nbContextMenu]="userMenu"
               [onlyPicture]="userPictureOnly"
               [name]="user?.name"
               [picture]="user?.picture">
      </nb-user>
    </nb-action> -->

  </nb-actions>
  <div class="logo-container">
    <a class="logo" (click)="navigateHome()">
      <img style="width:145px !important;    position: relative;right: 8px !important;
    top: 11px !important;" src="assets/images/logo/side-bar-logo.png" />
    </a>
    <!-- <br> -->

  </div>
  <!-- <span class="version">ver 2.2.1</span> -->
</div>